(function() {
  const DATA = window.KFZ_TUNING_DATA;
  if (!DATA || !Array.isArray(DATA.brands)) {
    console.error("KFZ-Konfigurator: Tuning-Daten konnten nicht geladen werden.");
    return;
  }

  function initConfigurator(root) {
    if (!root || root.dataset.ready === "true") return;
    const els = {
      brand: root.querySelector('[data-role="brand"]'),
      model: root.querySelector('[data-role="model"]'),
      year: root.querySelector('[data-role="year"]'),
      motor: root.querySelector('[data-role="motor"]'),
      results: root.querySelector('[data-role="results"]'),
      brandMark: root.querySelector('[data-role="brand-mark"]'),
      vehicleName: root.querySelector('[data-role="vehicle-name"]'),
      tabs: root.querySelector('[data-role="tabs"]'),
      stage: root.querySelector('[data-role="stage"]'),
      options: root.querySelector('[data-role="options"]')
    };
    const state = { brandId: "", modelId: "", yearId: "", motorId: "", stageKey: "" };
    const svgNS = "http://www.w3.org/2000/svg";

    function byId(items, id) { return items.find((item) => item.id === id) || null; }
    function current() {
      const brand = byId(DATA.brands, state.brandId);
      const model = brand ? byId(brand.models, state.modelId) : null;
      const year = model ? byId(model.years, state.yearId) : null;
      const motor = year ? byId(year.motors, state.motorId) : null;
      return { brand, model, year, motor };
    }
    function addOption(select, value, label) {
      const option = document.createElement("option");
      option.value = value;
      option.textContent = label;
      select.appendChild(option);
    }
    function fillSelect(select, items, placeholder, selectedId) {
      select.replaceChildren();
      addOption(select, "", placeholder);
      items.forEach((item) => addOption(select, item.id, item.name));
      select.disabled = items.length === 0;
      select.value = items.some((item) => item.id === selectedId) ? selectedId : "";
    }
    function validStage(stage) {
      return [stage.psOriginal, stage.psTuned, stage.nmOriginal, stage.nmTuned].every((value) => Number(value) > 0);
    }
    function availableStages(motor) {
      if (!motor) return [];
      return motor.stages.filter((stage) => validStage(stage) && (stage.key !== "eco" || motor.fuel === "Diesel"));
    }
    function svgEl(name, attrs) {
      const node = document.createElementNS(svgNS, name);
      Object.entries(attrs || {}).forEach(([key, value]) => node.setAttribute(key, value));
      return node;
    }
    function arcPath(cx, cy, radius, start, end) {
      const toPoint = (angle) => {
        const radians = (angle - 180) * Math.PI / 180;
        return { x: cx + radius * Math.cos(radians), y: cy + radius * Math.sin(radians) };
      };
      const a = toPoint(start);
      const b = toPoint(end);
      return "M " + a.x.toFixed(2) + " " + a.y.toFixed(2) + " A " + radius + " " + radius + " 0 0 1 " + b.x.toFixed(2) + " " + b.y.toFixed(2);
    }
    function gauge(label, unit, original, tuned, percent) {
      const gainPercent = Number(percent) || Math.round(((Number(tuned) - Number(original)) / Number(original)) * 100);
      const split = Math.max(24, Math.min(166, (Number(original) / (Number(original) + gainPercent)) * 180));
      const wrap = document.createElement("div");
      wrap.className = "kc-gauge";
      const title = document.createElement("div");
      title.className = "kc-gauge-title";
      title.textContent = label + " + " + gainPercent + "%";
      const svg = svgEl("svg", { viewBox: "0 0 200 120", role: "img", "aria-label": label + ": Original " + original + " " + unit + ", Tuning " + tuned + " " + unit });
      const svgTitle = svgEl("title");
      svgTitle.textContent = label + " Leistungszuwachs";
      const originalPath = svgEl("path", { class: "kc-gauge-path kc-gauge-original", d: arcPath(100, 105, 68, 0, split), pathLength: "100" });
      const stagePath = svgEl("path", { class: "kc-gauge-path kc-gauge-stage", d: arcPath(100, 105, 68, split, 180), pathLength: "100" });
      const orgLabel = svgEl("text", { class: "kc-gauge-label", x: "64", y: "76", "text-anchor": "middle" });
      orgLabel.textContent = "Org";
      const stgLabel = svgEl("text", { class: "kc-gauge-label", x: "149", y: "87", "text-anchor": "middle" });
      stgLabel.textContent = "Stg";
      svg.append(svgTitle, originalPath, stagePath, orgLabel, stgLabel);
      wrap.append(title, svg);
      return wrap;
    }
    function metricRow(name, unit, original, tuned, diff, percent, metricKey) {
      const row = document.createElement("div");
      row.className = "kc-metric-row";
      const metric = document.createElement("div");
      metric.className = "kc-metric-name";
      metric.textContent = name + ":";
      const originalNode = document.createElement("div");
      originalNode.className = "kc-original";
      originalNode.innerHTML = original + ' <span class="kc-unit">(' + unit + ")</span>";
      const arrow = document.createElement("div");
      arrow.className = "kc-arrow";
      arrow.setAttribute("aria-hidden", "true");
      arrow.textContent = "⇨";
      const tuning = document.createElement("div");
      tuning.className = "kc-tuning";
      tuning.dataset.metric = metricKey;
      const tunedNode = document.createElement("div");
      tunedNode.className = "kc-tuned";
      tunedNode.innerHTML = tuned + ' <span class="kc-unit">(' + unit + ")</span>";
      const gain = document.createElement("div");
      gain.className = "kc-gain";
      gain.textContent = "+" + diff;
      tuning.append(tunedNode, gain);
      row.append(metric, originalNode, arrow, tuning, gauge(metricKey === "ps" ? "PS" : "Nm", unit, original, tuned, percent));
      return row;
    }
    function performanceBoard(stage) {
      const board = document.createElement("div");
      board.className = "kc-performance-board";
      const head = document.createElement("div");
      head.className = "kc-board-head";
      head.innerHTML = '<span></span><span class="kc-board-head-label">Original</span><span></span><span class="kc-board-head-label">Tuning</span><span></span>';
      board.append(
        head,
        metricRow("LEISTUNG", "PS", stage.psOriginal, stage.psTuned, stage.psDiff, stage.psPercent, "ps"),
        metricRow("DREHMOMENT", "NM", stage.nmOriginal, stage.nmTuned, stage.nmDiff, stage.nmPercent, "nm")
      );
      return board;
    }
    function renderOptions(stages) {
      const hasStage = (key) => stages.some((stage) => stage.key === key);
      const options = [
        ["Stage 1", "ST1", hasStage("stage1")],
        ["Stage 2", "ST2", hasStage("stage2")],
        ["V-Max Off", "VM", true],
        ["DPF / FAP off", "DPF", true],
        ["AGR off", "AGR", true],
        ["Fehlercodes off / DTC", "DTC", true],
        ["Öko Tuning", "ECO", hasStage("eco")]
      ];
      els.options.replaceChildren();
      options.filter((item) => item[2]).forEach(([label, code]) => {
        const option = document.createElement("div");
        option.className = "kc-option";
        const text = document.createElement("span");
        text.textContent = label;
        const icon = document.createElement("span");
        icon.className = "kc-option-icon";
        icon.setAttribute("aria-hidden", "true");
        icon.textContent = code;
        option.append(text, icon);
        els.options.appendChild(option);
      });
    }
    function animatePanel() {
      els.stage.classList.remove("is-switching");
      void els.stage.offsetWidth;
      els.stage.classList.add("is-switching");
    }
    function renderResults(opening) {
      const { brand, model, year, motor } = current();
      if (!motor) {
        els.results.hidden = true;
        return;
      }
      const stages = availableStages(motor);
      if (!stages.some((stage) => stage.key === state.stageKey)) state.stageKey = stages[0]?.key || "";
      const stage = stages.find((item) => item.key === state.stageKey) || null;
      els.brandMark.textContent = brand.name;
      els.vehicleName.textContent = motor.description || [brand.name, model.name, motor.name].join(" ");
      els.tabs.replaceChildren();
      stages.forEach((item) => {
        const button = document.createElement("button");
        button.type = "button";
        button.textContent = item.label;
        button.setAttribute("aria-pressed", item.key === state.stageKey ? "true" : "false");
        button.addEventListener("click", () => { state.stageKey = item.key; renderResults(false); });
        els.tabs.appendChild(button);
      });
      els.stage.replaceChildren();
      if (stage) els.stage.appendChild(performanceBoard(stage));
      else {
        const empty = document.createElement("div");
        empty.className = "kc-empty";
        empty.textContent = "Für diese Motorvariante sind keine Leistungsdaten hinterlegt.";
        els.stage.appendChild(empty);
      }
      renderOptions(stages);
      els.results.hidden = false;
      if (opening) {
        els.results.classList.remove("is-opening");
        void els.results.offsetWidth;
        els.results.classList.add("is-opening");
      }
      animatePanel();
    }
    function resetAfter(level) {
      if (level === "brand") { state.modelId = ""; state.yearId = ""; state.motorId = ""; }
      if (level === "model") { state.yearId = ""; state.motorId = ""; }
      if (level === "year") state.motorId = "";
      state.stageKey = "";
    }
    fillSelect(els.brand, DATA.brands, "Hersteller", "");
    fillSelect(els.model, [], "Modell", "");
    fillSelect(els.year, [], "Baujahr", "");
    fillSelect(els.motor, [], "Motor", "");
    els.brand.addEventListener("change", () => {
      state.brandId = els.brand.value;
      resetAfter("brand");
      const brand = byId(DATA.brands, state.brandId);
      fillSelect(els.model, brand?.models || [], "Modell", "");
      fillSelect(els.year, [], "Baujahr", "");
      fillSelect(els.motor, [], "Motor", "");
      renderResults(false);
    });
    els.model.addEventListener("change", () => {
      state.modelId = els.model.value;
      resetAfter("model");
      const { model } = current();
      fillSelect(els.year, model?.years || [], "Baujahr", "");
      fillSelect(els.motor, [], "Motor", "");
      renderResults(false);
    });
    els.year.addEventListener("change", () => {
      state.yearId = els.year.value;
      resetAfter("year");
      const { year } = current();
      fillSelect(els.motor, year?.motors || [], "Motor", "");
      renderResults(false);
    });
    els.motor.addEventListener("change", () => {
      state.motorId = els.motor.value;
      state.stageKey = "";
      renderResults(Boolean(state.motorId));
    });
    root.dataset.ready = "true";
  }

  function initAll(scope) {
    const selector = "[data-kfz-konfigurator]";
    if (scope.matches && scope.matches(selector)) initConfigurator(scope);
    scope.querySelectorAll(selector).forEach(initConfigurator);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
